export default {
  "tab.title": "Tools",
  list: "Tools",
  "seo.name": "SEO",

  "seo.title": "Website audit",
  "seo.description":
    "Google Lighthouse scores and technical checks for the app in this project, or for any website.",
  "target.preview": "This project",
  "target.url": "Website",
  "url.label": "Website address",
  "url.placeholder": "example.com",
  "formFactor.mobile": "Mobile",
  "formFactor.desktop": "Desktop",
  "action.create": "Create audit",
  "action.retest": "Test again",
  "action.running": "Auditing",
  "action.cancel": "Cancel",
  "action.report": "Report / PDF",
  "running.title": "Website audit running …",
  "running.preview": "Starting the preview …",
  "running.lighthouse": "Measuring the page with Lighthouse. This takes up to a minute.",
  "empty.title": "No audit yet",
  "empty.description": "Create an audit to score the app this project is building, or enter any website address.",
  failed: "The audit could not run: {{reason}}",

  "overall.kicker": "Website audit",
  "verdict.excellent": "Very good",
  "verdict.good": "Good",
  "verdict.fair": "Room for improvement",
  "verdict.poor": "Urgent action needed",
  scanned: "Scanned {{date}}",

  source: "Lighthouse (Google)",
  "lighthouse.unavailable": "Lighthouse could not run: {{reason}}",
  "gauge.performance": "Performance",
  "gauge.accessibility": "Accessibility",
  "gauge.bestPractices": "Best Practices",
  "gauge.seo": "SEO",
  "gauge.agentic": "Agentic",
  "category.agentic": "Agentic Browsing",
  "metric.speedIndex": "Speed Index",
  "agentic.passed": "Agentic Browsing: {{passed}}/{{total}} checks passed",
  findings: "Lighthouse findings ({{count}})",
  audited: "Audited",
  "severity.error": "Error",
  "severity.warning": "Warning",

  "technical.title": "Technical analysis",
  "technical.unavailable": "The page could not be fetched: {{reason}}",
  "technical.status": "HTTP status",
  "technical.loadTime": "Load time",
  "technical.ttfb": "TTFB",
  "technical.size": "Page size",
  "technical.https": "HTTPS",
  "technical.https.yes": "Yes, active",
  "technical.https.no": "No",
  "technical.certificate": "Certificate",
  "technical.certificate.days.one": "{{count}} day",
  "technical.certificate.days.other": "{{count}} days",
  "technical.country": "Country/Domain",
  "technical.cms": "CMS",
  "technical.server": "Server",
  "technical.links": "Links checked",

  "checks.title": "Own checks – findings",
  "checks.summary.one": "{{count}} finding, {{major}} of them significant (critical/high/medium).",
  "checks.summary.other": "{{count}} findings, {{major}} of them significant (critical/high/medium).",
  "checks.none": "Our own checks found nothing to improve.",
  "group.reachability": "Reachability & errors",
  "group.geo": "GEO",
  "group.agentic": "Agentic",
  "group.design": "Design & UX",
  "group.technical": "Further technical notes",
  "severity.critical": "Critical",
  "severity.high": "High",
  "severity.medium": "Medium",
  "severity.low": "Low",
  "severity.optional": "Optional",
  "severity.info": "Info",

  "check.status-error.title": "The page answers with an error",
  "check.status-error.detail": "The server answered with HTTP {{status}}. Visitors and search engines see an error page.",
  "check.broken-links.title": "Broken internal links ({{count}})",
  "check.broken-links.detail": "Broken links: {{links}}",
  "check.slow-response.title": "Slow server response",
  "check.slow-response.detail": "The first byte arrived after {{ms}} ms. Below 800 ms is recommended.",
  "check.noindex.title": "The page tells search engines not to index it",
  "check.noindex.detail": "A robots meta tag contains noindex, so the page does not appear in search results.",
  "check.no-local-business.title": "No LocalBusiness schema (GEO)",
  "check.no-local-business.detail":
    "Structured location data can help search engines understand business and location details. Its absence alone does not prove a lower ranking.",
  "check.no-lang.title": "No page language set",
  "check.no-lang.detail": "The html element has no lang attribute, so browsers and search engines must guess the language.",
  "check.no-structured-data.title": "Structured data missing (Schema.org; recommendation)",
  "check.no-structured-data.detail":
    "AI assistants and search engines can classify and cite content less well without structured data.",
  "check.no-llms-txt.title": "No llms.txt",
  "check.no-llms-txt.detail": "Not a legal requirement; a possible guide for AI systems, without a guaranteed effect.",
  "check.no-social-image.title": "No social preview with an image (Design)",
  "check.no-social-image.detail":
    "When shared on WhatsApp, LinkedIn and others, an appealing preview with an image is missing – that costs clicks.",
  "check.no-viewport.title": "No mobile viewport",
  "check.no-viewport.detail": "Without a viewport meta tag, phones show the page zoomed out as on a desktop.",
  "check.no-favicon.title": "No favicon",
  "check.no-favicon.detail": "No icon appears in the browser tab and in bookmarks.",
  "check.no-theme-color.title": "No theme color (Design)",
  "check.no-theme-color.detail": "The mobile browser bar is not shown in the brand color (meta theme-color is missing).",
  "check.no-title.title": "No page title",
  "check.no-title.detail": "Search results and browser tabs have no title to show.",
  "check.no-description.title": "No meta description",
  "check.no-description.detail": "Search engines pick a random snippet instead of a description you wrote.",
  "check.no-h1.title": "No main heading (H1)",
  "check.no-h1.detail": "The page has no H1, which helps readers and search engines see what it is about.",
  "check.many-h1.title": "Several main headings (H1): {{count}}",
  "check.many-h1.detail": "One H1 per page is recommended so its main topic is clear.",
  "check.no-canonical.title": "No canonical link",
  "check.no-canonical.detail": "A canonical link tells search engines which address is the original when content repeats.",
  "check.no-https.title": "No HTTPS",
  "check.no-https.detail": "The page loads without encryption. Browsers mark it as not secure.",
  "check.no-hsts.title": "HSTS missing",
  "check.no-hsts.detail":
    "The HSTS header is missing. It can tell browsers to open the site only over HTTPS from now on; its absence is not automatically a legal violation.",
  "check.no-csp.title": "No Content Security Policy",
  "check.no-csp.detail":
    "A CSP can reduce certain risks from injected scripts. Its absence alone does not prove an exploitable vulnerability.",
  "check.no-clickjacking.title": "No protection against clickjacking",
  "check.no-clickjacking.detail": "X-Frame-Options or CSP frame-ancestors is missing.",
  "check.certificate-expiring.title": "The certificate expires soon",
  "check.certificate-expiring.detail": "The TLS certificate expires in {{days}} days. Renew it before visitors see warnings.",
  "check.mixed-content.title": "Insecure content on a secure page",
  "check.mixed-content.detail": "{{count}} resources load over plain HTTP, which browsers block or warn about.",
  "check.legacy-analytics.title": "Outdated Google Analytics (UA) included",
  "check.legacy-analytics.detail": "Universal Analytics was switched off and no longer collects data. Move to GA4.",
  "check.no-robots.title": "No robots.txt",
  "check.no-robots.detail": "Search engines find no instructions for crawling the site.",
  "check.no-sitemap.title": "No sitemap.xml",
  "check.no-sitemap.detail": "A sitemap helps search engines find every page.",
  "check.no-referrer-policy.title": "Referrer-Policy missing",
  "check.no-referrer-policy.detail":
    "Controls which referrer information is sent to other sites. Technical recommendation.",
  "check.no-permissions-policy.title": "Permissions-Policy missing",
  "check.no-permissions-policy.detail":
    "Can restrict access to browser features. Not on its own proof of a legal violation.",

  "optimize.title": "Fix with AI",
  "optimize.description":
    "The AI fixes them in this project's code, then the audit runs again to show what changed.",
  "optimize.all": "Fix all with AI",
  "optimize.fixOne": "Fix",
  "optimize.issueCount.one": "{{count}} finding",
  "optimize.issueCount.other": "{{count}} findings",
  "optimize.agentBusy": "The agent is busy – wait for the current task to finish.",
  "optimize.noSession": "Open this from a session to use the AI.",
  "optimize.website": "Fixes change this project's code. Audit the project's preview to measure them.",
  "optimize.working": "Working on the fixes …",
  "optimize.auditing": "Measuring again …",
  "optimize.workingAll.one": "Implementing the fix for {{count}} finding.",
  "optimize.workingAll.other": "Implementing fixes for {{count}} findings.",
  "optimize.workingOne": "Implementing the fix for this finding.",
  "optimize.stop": "Stop",
  "optimize.stopped": "Stopped. Test again when you are ready to continue.",
  "optimize.failed": "The request did not reach the agent: {{reason}}",
  "optimize.auditFailed": "Fixes were applied but the follow-up audit could not run.",
  "optimize.result.title": "What changed",
  "optimize.result.summary": "{{fixed}} of {{total}} findings resolved",
  "optimize.result.noProgress": "No measured improvement yet.",
  "optimize.result.retry": "Run another pass",
  "optimize.result.dismiss": "Dismiss",
  "optimize.change.fixed": "Fixed",
  "optimize.change.remaining": "Still failing",
  "optimize.change.introduced": "New",
  "optimize.overall": "Overall",

  "history.title": "History",
  "history.remove": "Remove report",
  "history.preview": "Project preview",

  "report.making": "Making the PDF …",
  "report.failed": "The PDF could not be made: {{reason}}",

  "pdf.subtitle": "AI web development",
  "pdf.kicker": "Website audit",
  "pdf.number": "No. {{number}}",
  "pdf.client": "Client",
  "pdf.location": "Place",
  "pdf.website": "Website",
  "pdf.scan": "Scan",
  "pdf.heading": "Website audit: {{client}}",
  "pdf.intro": "Assessment of the website {{site}} based on Google Lighthouse and our own technical review.",
  "pdf.overall": "Overall score {{score}} / 100 – {{verdict}}",
  "pdf.overview": "Score overview (Lighthouse)",
  "pdf.area": "Area",
  "pdf.score": "Score",
  "pdf.rating": "Rating",
  "rating.critical": "Critical",
  "rating.improve": "Needs improvement",
  "rating.good": "Very good",
  "pdf.measured": "Measured: {{time}} · Page checked: {{url}} · Saved: {{saved}}",
  "pdf.metrics": "Lighthouse metrics",
  "pdf.technical": "Technical metrics",
  "pdf.checks": "Own checks – findings",
  "pdf.severity": "Severity",
  "pdf.finding": "Finding",
  "pdf.details": "Details",
  "pdf.lighthouse": "Lighthouse notes",
  "pdf.status": "Status",
  "pdf.audit": "Audit",
  "pdf.value": "Value",
  "pdf.created": "Created {{created}} · Scan of {{scan}}",
  "pdf.page": "Page",
  "pdf.legalKicker": "Website audit · Legal classification",

  "pdf.legal.title": "Legal classification and limits of the audit",
  "pdf.legal.intro":
    "This report documents technical observations at the stated time of the audit. It is not a legal opinion, not a penetration test and not a confirmation that the website fully complies with the law.",
  "pdf.legal.clarifications": "Important clarifications",
  "pdf.legal.recommendations.title": "Technical recommendations are not legal obligations.",
  "pdf.legal.recommendations.body":
    "The absence of HSTS, a Content Security Policy, a Referrer-Policy, a Permissions-Policy, a favicon or llms.txt is not on its own proof of a legal violation. llms.txt is not a general legal requirement.",
  "pdf.legal.structured.title": "Structured data and search engines.",
  "pdf.legal.structured.body":
    "Schema.org markup can help machines classify content. Missing markup proves neither a legal violation nor a specific drop in ranking.",
  "pdf.legal.privacy.title": "Data protection depends on the actual use.",
  "pdf.legal.privacy.body":
    "Whether duties to inform, to allow objection or to ask for consent apply depends, among other things, on which personal data, cookies and tracking technologies are actually used and which audiences are addressed. This technical scan does not settle that.",
  "pdf.legal.scores.title": "Scores and measurements.",
  "pdf.legal.scores.body":
    "Lighthouse scores are snapshots and can change with the device, network, cache and run. “Agentic Browsing” is an additional rating and not an official Lighthouse score.",

  "pdf.notes.title": "Notes on validity and use",
  "pdf.notes.subtitle": "{{client}} / {{site}} / Supplement to the technical website audit",
  "pdf.notes.purpose.title": "01 Purpose and scope",
  "pdf.notes.purpose.body":
    "The report documents a technical snapshot of the named website based on the automated measurements and checks listed in the main part. It is meant to make technical issues visible and to prioritize possible improvements. It is neither a legal opinion nor a complete security, data protection, accessibility or compliance review.",
  "pdf.notes.validity.title": "02 Validity of the results",
  "pdf.notes.validity.body":
    "Scores, metrics and ratings depend on, among other things, the time of the test, the test environment, network, device, browser, cache and the tools used. Automated tests do not catch every error or risk. The “Agentic Browsing” category is a supplementary, provider-specific rating and not an official Lighthouse metric. The values must not be understood as an official certification or guarantee.",
  "pdf.notes.violations.title": "03 Technical notes are not automatically legal violations",
  "pdf.notes.violations.body":
    "A missing HTTP header, missing structured data or another technical finding does not on its own prove a legal violation, an exploitable security gap or a specific loss in ranking. Such statements require a review of the facts and their context. Findings with legal relevance should be verified manually and documented traceably before a binding assessment.",
  "pdf.notes.privacy.title": "04 Data protection and tracking",
  "pdf.notes.privacy.body":
    "This audit does not confirm whether the website meets all applicable data protection requirements. That would need a separate review of the actual data processing and data flows, including contact forms, cookies and tracking, embedded third parties, privacy notices, retention periods and any required information or consent mechanisms. No unverified statements on these points are derived from this scan.",
  "pdf.notes.fair.title": "05 Factual and fair communication",
  "pdf.notes.fair.body":
    "When passed on, the report is to be used in full and with its audit date. Individual notes should not be called confirmed legal violations, security gaps or guaranteed economic disadvantages unless there is sufficient evidence. Statements about method, scope, qualification and results must be accurate, traceable and not misleading.",
  "pdf.notes.qa.title": "06 Recommended quality assurance",
  "pdf.notes.qa.area": "Area",
  "pdf.notes.qa.check": "Recommended check before a binding statement",
  "pdf.notes.qa.technical": "Technical findings",
  "pdf.notes.qa.technical.body": "Reproduce the finding; document URL, time, test environment, tool and result.",
  "pdf.notes.qa.privacy": "Data protection",
  "pdf.notes.qa.privacy.body": "Review the actual data processing, tracking, third parties and privacy notices separately.",
  "pdf.notes.qa.security": "Security",
  "pdf.notes.qa.security.body":
    "Where needed, carry out an authorized manual security test. Do not derive a security guarantee from an automated scan.",
  "pdf.notes.qa.accessibility": "Accessibility",
  "pdf.notes.qa.accessibility.body":
    "Check automated notes manually; claim conformance with a standard only after a suitable review.",
  "pdf.notes.qa.external": "External use",
  "pdf.notes.qa.external.body": "For legally or commercially significant statements, get an individual legal review.",
  "pdf.notes.reference":
    "Legal reference: the classification refers in general to the applicable data protection and fair competition law. Which provisions apply in a given case depends on the specific circumstances.",
  "pdf.notes.limitation.title": "Important limitation",
  "pdf.notes.limitation.body":
    "Notes and disclaimers can reduce misunderstandings, but they cannot exclude a legal obligation or guarantee freedom from liability. The actual execution, the accuracy of the information, the contractual framework and the specific use of the report remain decisive. This supplement does not replace individual legal advice.",
}
